/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppCallbackRouteImport } from './routes/_app/callback'
import { Route as AppStudioRouteRouteImport } from './routes/_app/studio/route'
import { Route as AppSettingsRouteRouteImport } from './routes/_app/settings/route'
import { Route as AppLogsRouteRouteImport } from './routes/_app/logs/route'
import { Route as AppLibraryRouteRouteImport } from './routes/_app/library/route'
import { Route as AppLensRouteRouteImport } from './routes/_app/lens/route'
import { Route as AppControlRoomRouteRouteImport } from './routes/_app/control-room/route'
import { Route as AppAssetLibraryRouteRouteImport } from './routes/_app/asset-library/route'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppLogsIndexRouteImport } from './routes/_app/logs/index'
import { Route as AppLibraryIndexRouteImport } from './routes/_app/library/index'
import { Route as AppLensIndexRouteImport } from './routes/_app/lens/index'
import { Route as AppControlRoomIndexRouteImport } from './routes/_app/control-room/index'
import { Route as AppAssetLibraryIndexRouteImport } from './routes/_app/asset-library/index'
import { Route as AppStudioRobotTeachingRouteRouteImport } from './routes/_app/studio/robot-teaching/route'
import { Route as AppStudioViewRouteRouteImport } from './routes/_app/studio/$view/route'
import { Route as AppSettingsSecretsRouteRouteImport } from './routes/_app/settings/secrets/route'
import { Route as AppSettingsLabRouteRouteImport } from './routes/_app/settings/lab/route'
import { Route as AppSettingsComplianceRouteRouteImport } from './routes/_app/settings/compliance/route'
import { Route as AppSettingsAuditExportsRouteRouteImport } from './routes/_app/settings/audit-exports/route'
import { Route as AppSettingsUserManagementRouteRouteImport } from './routes/_app/settings/_userManagement/route'
import { Route as AppLogsUserRouteRouteImport } from './routes/_app/logs/user/route'
import { Route as AppLogsExecutionRouteRouteImport } from './routes/_app/logs/execution/route'
import { Route as AppLibraryWorkflowsRouteRouteImport } from './routes/_app/library/workflows/route'
import { Route as AppLibraryProcessesRouteRouteImport } from './routes/_app/library/processes/route'
import { Route as AppControlRoomWorkflowRouteRouteImport } from './routes/_app/control-room/workflow/route'
import { Route as AppControlRoomProcessRouteRouteImport } from './routes/_app/control-room/process/route'
import { Route as AppLibraryWorkflowsIndexRouteImport } from './routes/_app/library/workflows/index'
import { Route as AppLibraryProcessesIndexRouteImport } from './routes/_app/library/processes/index'
import { Route as AppLensAnalysisIdIndexRouteImport } from './routes/_app/lens/$analysisId/index'
import { Route as AppAssetLibraryPackageIdIndexRouteImport } from './routes/_app/asset-library/$packageId/index'
import { Route as AppNotebookSessionSessionIdRouteImport } from './routes/_app/notebook/session/$sessionId'
import { Route as AppSettingsUserManagementUsersRouteRouteImport } from './routes/_app/settings/_userManagement/users/route'
import { Route as AppSettingsUserManagementRolesRouteRouteImport } from './routes/_app/settings/_userManagement/roles/route'
import { Route as AppLibraryWorkflowsWorkflowIdRouteRouteImport } from './routes/_app/library/workflows/$workflowId/route'
import { Route as AppLibraryWorkflowsWorkcellIdRouteRouteImport } from './routes/_app/library/workflows/$workcellId/route'
import { Route as AppLibraryProcessesProcessIdRouteRouteImport } from './routes/_app/library/processes/$processId/route'
import { Route as AppControlRoomWorkflowStepIdRouteRouteImport } from './routes/_app/control-room/workflow/$stepId/route'
import { Route as AppControlRoomProcessProcessIdRouteRouteImport } from './routes/_app/control-room/process/$processId/route'
import { Route as AppLibraryWorkflowsWorkflowIdIndexRouteImport } from './routes/_app/library/workflows/$workflowId/index'
import { Route as AppLibraryProcessesProcessIdIndexRouteImport } from './routes/_app/library/processes/$processId/index'
import { Route as AppControlRoomWorkflowParallelIndexRouteImport } from './routes/_app/control-room/workflow/parallel/index'
import { Route as AppControlRoomWorkflowStepIdIndexRouteImport } from './routes/_app/control-room/workflow/$stepId/index'
import { Route as AppControlRoomProcessProcessIdIndexRouteImport } from './routes/_app/control-room/process/$processId/index'
import { Route as AppAssetLibraryPackageIdAssetIdIndexRouteImport } from './routes/_app/asset-library/$packageId/$assetId/index'
import { Route as AppLibraryWorkflowsWorkflowIdCanvasRouteRouteImport } from './routes/_app/library/workflows/$workflowId/canvas/route'
import { Route as AppLibraryWorkflowsWorkcellIdWorkflowIdRouteRouteImport } from './routes/_app/library/workflows/$workcellId/$workflowId/route'
import { Route as AppLibraryProcessesProcessIdCanvasRouteRouteImport } from './routes/_app/library/processes/$processId/canvas/route'
import { Route as AppControlRoomProcessProcessIdLabwareLabwareIdRouteImport } from './routes/_app/control-room/process/$processId/labware/$labwareId'

const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppCallbackRoute = AppCallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppStudioRouteRoute = AppStudioRouteRouteImport.update({
  id: '/studio',
  path: '/studio',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsRouteRoute = AppSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppLogsRouteRoute = AppLogsRouteRouteImport.update({
  id: '/logs',
  path: '/logs',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppLibraryRouteRoute = AppLibraryRouteRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppLensRouteRoute = AppLensRouteRouteImport.update({
  id: '/lens',
  path: '/lens',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppControlRoomRouteRoute = AppControlRoomRouteRouteImport.update({
  id: '/control-room',
  path: '/control-room',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAssetLibraryRouteRoute = AppAssetLibraryRouteRouteImport.update({
  id: '/asset-library',
  path: '/asset-library',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppLogsIndexRoute = AppLogsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppLogsRouteRoute,
} as any)
const AppLibraryIndexRoute = AppLibraryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppLibraryRouteRoute,
} as any)
const AppLensIndexRoute = AppLensIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppLensRouteRoute,
} as any)
const AppControlRoomIndexRoute = AppControlRoomIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppControlRoomRouteRoute,
} as any)
const AppAssetLibraryIndexRoute = AppAssetLibraryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAssetLibraryRouteRoute,
} as any)
const AppStudioRobotTeachingRouteRoute =
  AppStudioRobotTeachingRouteRouteImport.update({
    id: '/robot-teaching',
    path: '/robot-teaching',
    getParentRoute: () => AppStudioRouteRoute,
  } as any)
const AppStudioViewRouteRoute = AppStudioViewRouteRouteImport.update({
  id: '/$view',
  path: '/$view',
  getParentRoute: () => AppStudioRouteRoute,
} as any)
const AppSettingsSecretsRouteRoute = AppSettingsSecretsRouteRouteImport.update({
  id: '/secrets',
  path: '/secrets',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsLabRouteRoute = AppSettingsLabRouteRouteImport.update({
  id: '/lab',
  path: '/lab',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsComplianceRouteRoute =
  AppSettingsComplianceRouteRouteImport.update({
    id: '/compliance',
    path: '/compliance',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsAuditExportsRouteRoute =
  AppSettingsAuditExportsRouteRouteImport.update({
    id: '/audit-exports',
    path: '/audit-exports',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsUserManagementRouteRoute =
  AppSettingsUserManagementRouteRouteImport.update({
    id: '/_userManagement',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppLogsUserRouteRoute = AppLogsUserRouteRouteImport.update({
  id: '/user',
  path: '/user',
  getParentRoute: () => AppLogsRouteRoute,
} as any)
const AppLogsExecutionRouteRoute = AppLogsExecutionRouteRouteImport.update({
  id: '/execution',
  path: '/execution',
  getParentRoute: () => AppLogsRouteRoute,
} as any)
const AppLibraryWorkflowsRouteRoute =
  AppLibraryWorkflowsRouteRouteImport.update({
    id: '/workflows',
    path: '/workflows',
    getParentRoute: () => AppLibraryRouteRoute,
  } as any)
const AppLibraryProcessesRouteRoute =
  AppLibraryProcessesRouteRouteImport.update({
    id: '/processes',
    path: '/processes',
    getParentRoute: () => AppLibraryRouteRoute,
  } as any)
const AppControlRoomWorkflowRouteRoute =
  AppControlRoomWorkflowRouteRouteImport.update({
    id: '/workflow',
    path: '/workflow',
    getParentRoute: () => AppControlRoomRouteRoute,
  } as any)
const AppControlRoomProcessRouteRoute =
  AppControlRoomProcessRouteRouteImport.update({
    id: '/process',
    path: '/process',
    getParentRoute: () => AppControlRoomRouteRoute,
  } as any)
const AppLibraryWorkflowsIndexRoute =
  AppLibraryWorkflowsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppLibraryWorkflowsRouteRoute,
  } as any)
const AppLibraryProcessesIndexRoute =
  AppLibraryProcessesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppLibraryProcessesRouteRoute,
  } as any)
const AppLensAnalysisIdIndexRoute = AppLensAnalysisIdIndexRouteImport.update({
  id: '/$analysisId/',
  path: '/$analysisId/',
  getParentRoute: () => AppLensRouteRoute,
} as any)
const AppAssetLibraryPackageIdIndexRoute =
  AppAssetLibraryPackageIdIndexRouteImport.update({
    id: '/$packageId/',
    path: '/$packageId/',
    getParentRoute: () => AppAssetLibraryRouteRoute,
  } as any)
const AppNotebookSessionSessionIdRoute =
  AppNotebookSessionSessionIdRouteImport.update({
    id: '/notebook/session/$sessionId',
    path: '/notebook/session/$sessionId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppSettingsUserManagementUsersRouteRoute =
  AppSettingsUserManagementUsersRouteRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AppSettingsUserManagementRouteRoute,
  } as any)
const AppSettingsUserManagementRolesRouteRoute =
  AppSettingsUserManagementRolesRouteRouteImport.update({
    id: '/roles',
    path: '/roles',
    getParentRoute: () => AppSettingsUserManagementRouteRoute,
  } as any)
const AppLibraryWorkflowsWorkflowIdRouteRoute =
  AppLibraryWorkflowsWorkflowIdRouteRouteImport.update({
    id: '/$workflowId',
    path: '/$workflowId',
    getParentRoute: () => AppLibraryWorkflowsRouteRoute,
  } as any)
const AppLibraryWorkflowsWorkcellIdRouteRoute =
  AppLibraryWorkflowsWorkcellIdRouteRouteImport.update({
    id: '/$workcellId',
    path: '/$workcellId',
    getParentRoute: () => AppLibraryWorkflowsRouteRoute,
  } as any)
const AppLibraryProcessesProcessIdRouteRoute =
  AppLibraryProcessesProcessIdRouteRouteImport.update({
    id: '/$processId',
    path: '/$processId',
    getParentRoute: () => AppLibraryProcessesRouteRoute,
  } as any)
const AppControlRoomWorkflowStepIdRouteRoute =
  AppControlRoomWorkflowStepIdRouteRouteImport.update({
    id: '/$stepId',
    path: '/$stepId',
    getParentRoute: () => AppControlRoomWorkflowRouteRoute,
  } as any)
const AppControlRoomProcessProcessIdRouteRoute =
  AppControlRoomProcessProcessIdRouteRouteImport.update({
    id: '/$processId',
    path: '/$processId',
    getParentRoute: () => AppControlRoomProcessRouteRoute,
  } as any)
const AppLibraryWorkflowsWorkflowIdIndexRoute =
  AppLibraryWorkflowsWorkflowIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppLibraryWorkflowsWorkflowIdRouteRoute,
  } as any)
const AppLibraryProcessesProcessIdIndexRoute =
  AppLibraryProcessesProcessIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppLibraryProcessesProcessIdRouteRoute,
  } as any)
const AppControlRoomWorkflowParallelIndexRoute =
  AppControlRoomWorkflowParallelIndexRouteImport.update({
    id: '/parallel/',
    path: '/parallel/',
    getParentRoute: () => AppControlRoomWorkflowRouteRoute,
  } as any)
const AppControlRoomWorkflowStepIdIndexRoute =
  AppControlRoomWorkflowStepIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppControlRoomWorkflowStepIdRouteRoute,
  } as any)
const AppControlRoomProcessProcessIdIndexRoute =
  AppControlRoomProcessProcessIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppControlRoomProcessProcessIdRouteRoute,
  } as any)
const AppAssetLibraryPackageIdAssetIdIndexRoute =
  AppAssetLibraryPackageIdAssetIdIndexRouteImport.update({
    id: '/$packageId/$assetId/',
    path: '/$packageId/$assetId/',
    getParentRoute: () => AppAssetLibraryRouteRoute,
  } as any)
const AppLibraryWorkflowsWorkflowIdCanvasRouteRoute =
  AppLibraryWorkflowsWorkflowIdCanvasRouteRouteImport.update({
    id: '/canvas',
    path: '/canvas',
    getParentRoute: () => AppLibraryWorkflowsWorkflowIdRouteRoute,
  } as any)
const AppLibraryWorkflowsWorkcellIdWorkflowIdRouteRoute =
  AppLibraryWorkflowsWorkcellIdWorkflowIdRouteRouteImport.update({
    id: '/$workflowId',
    path: '/$workflowId',
    getParentRoute: () => AppLibraryWorkflowsWorkcellIdRouteRoute,
  } as any)
const AppLibraryProcessesProcessIdCanvasRouteRoute =
  AppLibraryProcessesProcessIdCanvasRouteRouteImport.update({
    id: '/canvas',
    path: '/canvas',
    getParentRoute: () => AppLibraryProcessesProcessIdRouteRoute,
  } as any)
const AppControlRoomProcessProcessIdLabwareLabwareIdRoute =
  AppControlRoomProcessProcessIdLabwareLabwareIdRouteImport.update({
    id: '/labware/$labwareId',
    path: '/labware/$labwareId',
    getParentRoute: () => AppControlRoomProcessProcessIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/asset-library': typeof AppAssetLibraryRouteRouteWithChildren
  '/control-room': typeof AppControlRoomRouteRouteWithChildren
  '/lens': typeof AppLensRouteRouteWithChildren
  '/library': typeof AppLibraryRouteRouteWithChildren
  '/logs': typeof AppLogsRouteRouteWithChildren
  '/settings': typeof AppSettingsUserManagementRouteRouteWithChildren
  '/studio': typeof AppStudioRouteRouteWithChildren
  '/callback': typeof AppCallbackRoute
  '/control-room/process': typeof AppControlRoomProcessRouteRouteWithChildren
  '/control-room/workflow': typeof AppControlRoomWorkflowRouteRouteWithChildren
  '/library/processes': typeof AppLibraryProcessesRouteRouteWithChildren
  '/library/workflows': typeof AppLibraryWorkflowsRouteRouteWithChildren
  '/logs/execution': typeof AppLogsExecutionRouteRoute
  '/logs/user': typeof AppLogsUserRouteRoute
  '/settings/audit-exports': typeof AppSettingsAuditExportsRouteRoute
  '/settings/compliance': typeof AppSettingsComplianceRouteRoute
  '/settings/lab': typeof AppSettingsLabRouteRoute
  '/settings/secrets': typeof AppSettingsSecretsRouteRoute
  '/studio/$view': typeof AppStudioViewRouteRoute
  '/studio/robot-teaching': typeof AppStudioRobotTeachingRouteRoute
  '/asset-library/': typeof AppAssetLibraryIndexRoute
  '/control-room/': typeof AppControlRoomIndexRoute
  '/lens/': typeof AppLensIndexRoute
  '/library/': typeof AppLibraryIndexRoute
  '/logs/': typeof AppLogsIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/control-room/process/$processId': typeof AppControlRoomProcessProcessIdRouteRouteWithChildren
  '/control-room/workflow/$stepId': typeof AppControlRoomWorkflowStepIdRouteRouteWithChildren
  '/library/processes/$processId': typeof AppLibraryProcessesProcessIdRouteRouteWithChildren
  '/library/workflows/$workcellId': typeof AppLibraryWorkflowsWorkcellIdRouteRouteWithChildren
  '/library/workflows/$workflowId': typeof AppLibraryWorkflowsWorkflowIdRouteRouteWithChildren
  '/settings/roles': typeof AppSettingsUserManagementRolesRouteRoute
  '/settings/users': typeof AppSettingsUserManagementUsersRouteRoute
  '/notebook/session/$sessionId': typeof AppNotebookSessionSessionIdRoute
  '/asset-library/$packageId': typeof AppAssetLibraryPackageIdIndexRoute
  '/lens/$analysisId': typeof AppLensAnalysisIdIndexRoute
  '/library/processes/': typeof AppLibraryProcessesIndexRoute
  '/library/workflows/': typeof AppLibraryWorkflowsIndexRoute
  '/library/processes/$processId/canvas': typeof AppLibraryProcessesProcessIdCanvasRouteRoute
  '/library/workflows/$workcellId/$workflowId': typeof AppLibraryWorkflowsWorkcellIdWorkflowIdRouteRoute
  '/library/workflows/$workflowId/canvas': typeof AppLibraryWorkflowsWorkflowIdCanvasRouteRoute
  '/asset-library/$packageId/$assetId': typeof AppAssetLibraryPackageIdAssetIdIndexRoute
  '/control-room/process/$processId/': typeof AppControlRoomProcessProcessIdIndexRoute
  '/control-room/workflow/$stepId/': typeof AppControlRoomWorkflowStepIdIndexRoute
  '/control-room/workflow/parallel': typeof AppControlRoomWorkflowParallelIndexRoute
  '/library/processes/$processId/': typeof AppLibraryProcessesProcessIdIndexRoute
  '/library/workflows/$workflowId/': typeof AppLibraryWorkflowsWorkflowIdIndexRoute
  '/control-room/process/$processId/labware/$labwareId': typeof AppControlRoomProcessProcessIdLabwareLabwareIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/studio': typeof AppStudioRouteRouteWithChildren
  '/callback': typeof AppCallbackRoute
  '/control-room/process': typeof AppControlRoomProcessRouteRouteWithChildren
  '/control-room/workflow': typeof AppControlRoomWorkflowRouteRouteWithChildren
  '/logs/execution': typeof AppLogsExecutionRouteRoute
  '/logs/user': typeof AppLogsUserRouteRoute
  '/settings': typeof AppSettingsIndexRoute
  '/settings/audit-exports': typeof AppSettingsAuditExportsRouteRoute
  '/settings/compliance': typeof AppSettingsComplianceRouteRoute
  '/settings/lab': typeof AppSettingsLabRouteRoute
  '/settings/secrets': typeof AppSettingsSecretsRouteRoute
  '/studio/$view': typeof AppStudioViewRouteRoute
  '/studio/robot-teaching': typeof AppStudioRobotTeachingRouteRoute
  '/asset-library': typeof AppAssetLibraryIndexRoute
  '/control-room': typeof AppControlRoomIndexRoute
  '/lens': typeof AppLensIndexRoute
  '/library': typeof AppLibraryIndexRoute
  '/logs': typeof AppLogsIndexRoute
  '/library/workflows/$workcellId': typeof AppLibraryWorkflowsWorkcellIdRouteRouteWithChildren
  '/settings/roles': typeof AppSettingsUserManagementRolesRouteRoute
  '/settings/users': typeof AppSettingsUserManagementUsersRouteRoute
  '/notebook/session/$sessionId': typeof AppNotebookSessionSessionIdRoute
  '/asset-library/$packageId': typeof AppAssetLibraryPackageIdIndexRoute
  '/lens/$analysisId': typeof AppLensAnalysisIdIndexRoute
  '/library/processes': typeof AppLibraryProcessesIndexRoute
  '/library/workflows': typeof AppLibraryWorkflowsIndexRoute
  '/library/processes/$processId/canvas': typeof AppLibraryProcessesProcessIdCanvasRouteRoute
  '/library/workflows/$workcellId/$workflowId': typeof AppLibraryWorkflowsWorkcellIdWorkflowIdRouteRoute
  '/library/workflows/$workflowId/canvas': typeof AppLibraryWorkflowsWorkflowIdCanvasRouteRoute
  '/asset-library/$packageId/$assetId': typeof AppAssetLibraryPackageIdAssetIdIndexRoute
  '/control-room/process/$processId': typeof AppControlRoomProcessProcessIdIndexRoute
  '/control-room/workflow/$stepId': typeof AppControlRoomWorkflowStepIdIndexRoute
  '/control-room/workflow/parallel': typeof AppControlRoomWorkflowParallelIndexRoute
  '/library/processes/$processId': typeof AppLibraryProcessesProcessIdIndexRoute
  '/library/workflows/$workflowId': typeof AppLibraryWorkflowsWorkflowIdIndexRoute
  '/control-room/process/$processId/labware/$labwareId': typeof AppControlRoomProcessProcessIdLabwareLabwareIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteRouteWithChildren
  '/_app/asset-library': typeof AppAssetLibraryRouteRouteWithChildren
  '/_app/control-room': typeof AppControlRoomRouteRouteWithChildren
  '/_app/lens': typeof AppLensRouteRouteWithChildren
  '/_app/library': typeof AppLibraryRouteRouteWithChildren
  '/_app/logs': typeof AppLogsRouteRouteWithChildren
  '/_app/settings': typeof AppSettingsRouteRouteWithChildren
  '/_app/studio': typeof AppStudioRouteRouteWithChildren
  '/_app/callback': typeof AppCallbackRoute
  '/_app/control-room/process': typeof AppControlRoomProcessRouteRouteWithChildren
  '/_app/control-room/workflow': typeof AppControlRoomWorkflowRouteRouteWithChildren
  '/_app/library/processes': typeof AppLibraryProcessesRouteRouteWithChildren
  '/_app/library/workflows': typeof AppLibraryWorkflowsRouteRouteWithChildren
  '/_app/logs/execution': typeof AppLogsExecutionRouteRoute
  '/_app/logs/user': typeof AppLogsUserRouteRoute
  '/_app/settings/_userManagement': typeof AppSettingsUserManagementRouteRouteWithChildren
  '/_app/settings/audit-exports': typeof AppSettingsAuditExportsRouteRoute
  '/_app/settings/compliance': typeof AppSettingsComplianceRouteRoute
  '/_app/settings/lab': typeof AppSettingsLabRouteRoute
  '/_app/settings/secrets': typeof AppSettingsSecretsRouteRoute
  '/_app/studio/$view': typeof AppStudioViewRouteRoute
  '/_app/studio/robot-teaching': typeof AppStudioRobotTeachingRouteRoute
  '/_app/asset-library/': typeof AppAssetLibraryIndexRoute
  '/_app/control-room/': typeof AppControlRoomIndexRoute
  '/_app/lens/': typeof AppLensIndexRoute
  '/_app/library/': typeof AppLibraryIndexRoute
  '/_app/logs/': typeof AppLogsIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/control-room/process/$processId': typeof AppControlRoomProcessProcessIdRouteRouteWithChildren
  '/_app/control-room/workflow/$stepId': typeof AppControlRoomWorkflowStepIdRouteRouteWithChildren
  '/_app/library/processes/$processId': typeof AppLibraryProcessesProcessIdRouteRouteWithChildren
  '/_app/library/workflows/$workcellId': typeof AppLibraryWorkflowsWorkcellIdRouteRouteWithChildren
  '/_app/library/workflows/$workflowId': typeof AppLibraryWorkflowsWorkflowIdRouteRouteWithChildren
  '/_app/settings/_userManagement/roles': typeof AppSettingsUserManagementRolesRouteRoute
  '/_app/settings/_userManagement/users': typeof AppSettingsUserManagementUsersRouteRoute
  '/_app/notebook/session/$sessionId': typeof AppNotebookSessionSessionIdRoute
  '/_app/asset-library/$packageId/': typeof AppAssetLibraryPackageIdIndexRoute
  '/_app/lens/$analysisId/': typeof AppLensAnalysisIdIndexRoute
  '/_app/library/processes/': typeof AppLibraryProcessesIndexRoute
  '/_app/library/workflows/': typeof AppLibraryWorkflowsIndexRoute
  '/_app/library/processes/$processId/canvas': typeof AppLibraryProcessesProcessIdCanvasRouteRoute
  '/_app/library/workflows/$workcellId/$workflowId': typeof AppLibraryWorkflowsWorkcellIdWorkflowIdRouteRoute
  '/_app/library/workflows/$workflowId/canvas': typeof AppLibraryWorkflowsWorkflowIdCanvasRouteRoute
  '/_app/asset-library/$packageId/$assetId/': typeof AppAssetLibraryPackageIdAssetIdIndexRoute
  '/_app/control-room/process/$processId/': typeof AppControlRoomProcessProcessIdIndexRoute
  '/_app/control-room/workflow/$stepId/': typeof AppControlRoomWorkflowStepIdIndexRoute
  '/_app/control-room/workflow/parallel/': typeof AppControlRoomWorkflowParallelIndexRoute
  '/_app/library/processes/$processId/': typeof AppLibraryProcessesProcessIdIndexRoute
  '/_app/library/workflows/$workflowId/': typeof AppLibraryWorkflowsWorkflowIdIndexRoute
  '/_app/control-room/process/$processId/labware/$labwareId': typeof AppControlRoomProcessProcessIdLabwareLabwareIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/asset-library'
    | '/control-room'
    | '/lens'
    | '/library'
    | '/logs'
    | '/settings'
    | '/studio'
    | '/callback'
    | '/control-room/process'
    | '/control-room/workflow'
    | '/library/processes'
    | '/library/workflows'
    | '/logs/execution'
    | '/logs/user'
    | '/settings/audit-exports'
    | '/settings/compliance'
    | '/settings/lab'
    | '/settings/secrets'
    | '/studio/$view'
    | '/studio/robot-teaching'
    | '/asset-library/'
    | '/control-room/'
    | '/lens/'
    | '/library/'
    | '/logs/'
    | '/settings/'
    | '/control-room/process/$processId'
    | '/control-room/workflow/$stepId'
    | '/library/processes/$processId'
    | '/library/workflows/$workcellId'
    | '/library/workflows/$workflowId'
    | '/settings/roles'
    | '/settings/users'
    | '/notebook/session/$sessionId'
    | '/asset-library/$packageId'
    | '/lens/$analysisId'
    | '/library/processes/'
    | '/library/workflows/'
    | '/library/processes/$processId/canvas'
    | '/library/workflows/$workcellId/$workflowId'
    | '/library/workflows/$workflowId/canvas'
    | '/asset-library/$packageId/$assetId'
    | '/control-room/process/$processId/'
    | '/control-room/workflow/$stepId/'
    | '/control-room/workflow/parallel'
    | '/library/processes/$processId/'
    | '/library/workflows/$workflowId/'
    | '/control-room/process/$processId/labware/$labwareId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/studio'
    | '/callback'
    | '/control-room/process'
    | '/control-room/workflow'
    | '/logs/execution'
    | '/logs/user'
    | '/settings'
    | '/settings/audit-exports'
    | '/settings/compliance'
    | '/settings/lab'
    | '/settings/secrets'
    | '/studio/$view'
    | '/studio/robot-teaching'
    | '/asset-library'
    | '/control-room'
    | '/lens'
    | '/library'
    | '/logs'
    | '/library/workflows/$workcellId'
    | '/settings/roles'
    | '/settings/users'
    | '/notebook/session/$sessionId'
    | '/asset-library/$packageId'
    | '/lens/$analysisId'
    | '/library/processes'
    | '/library/workflows'
    | '/library/processes/$processId/canvas'
    | '/library/workflows/$workcellId/$workflowId'
    | '/library/workflows/$workflowId/canvas'
    | '/asset-library/$packageId/$assetId'
    | '/control-room/process/$processId'
    | '/control-room/workflow/$stepId'
    | '/control-room/workflow/parallel'
    | '/library/processes/$processId'
    | '/library/workflows/$workflowId'
    | '/control-room/process/$processId/labware/$labwareId'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_app/asset-library'
    | '/_app/control-room'
    | '/_app/lens'
    | '/_app/library'
    | '/_app/logs'
    | '/_app/settings'
    | '/_app/studio'
    | '/_app/callback'
    | '/_app/control-room/process'
    | '/_app/control-room/workflow'
    | '/_app/library/processes'
    | '/_app/library/workflows'
    | '/_app/logs/execution'
    | '/_app/logs/user'
    | '/_app/settings/_userManagement'
    | '/_app/settings/audit-exports'
    | '/_app/settings/compliance'
    | '/_app/settings/lab'
    | '/_app/settings/secrets'
    | '/_app/studio/$view'
    | '/_app/studio/robot-teaching'
    | '/_app/asset-library/'
    | '/_app/control-room/'
    | '/_app/lens/'
    | '/_app/library/'
    | '/_app/logs/'
    | '/_app/settings/'
    | '/_app/control-room/process/$processId'
    | '/_app/control-room/workflow/$stepId'
    | '/_app/library/processes/$processId'
    | '/_app/library/workflows/$workcellId'
    | '/_app/library/workflows/$workflowId'
    | '/_app/settings/_userManagement/roles'
    | '/_app/settings/_userManagement/users'
    | '/_app/notebook/session/$sessionId'
    | '/_app/asset-library/$packageId/'
    | '/_app/lens/$analysisId/'
    | '/_app/library/processes/'
    | '/_app/library/workflows/'
    | '/_app/library/processes/$processId/canvas'
    | '/_app/library/workflows/$workcellId/$workflowId'
    | '/_app/library/workflows/$workflowId/canvas'
    | '/_app/asset-library/$packageId/$assetId/'
    | '/_app/control-room/process/$processId/'
    | '/_app/control-room/workflow/$stepId/'
    | '/_app/control-room/workflow/parallel/'
    | '/_app/library/processes/$processId/'
    | '/_app/library/workflows/$workflowId/'
    | '/_app/control-room/process/$processId/labware/$labwareId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/callback': {
      id: '/_app/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof AppCallbackRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/studio': {
      id: '/_app/studio'
      path: '/studio'
      fullPath: '/studio'
      preLoaderRoute: typeof AppStudioRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/logs': {
      id: '/_app/logs'
      path: '/logs'
      fullPath: '/logs'
      preLoaderRoute: typeof AppLogsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/library': {
      id: '/_app/library'
      path: '/library'
      fullPath: '/library'
      preLoaderRoute: typeof AppLibraryRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/lens': {
      id: '/_app/lens'
      path: '/lens'
      fullPath: '/lens'
      preLoaderRoute: typeof AppLensRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/control-room': {
      id: '/_app/control-room'
      path: '/control-room'
      fullPath: '/control-room'
      preLoaderRoute: typeof AppControlRoomRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/asset-library': {
      id: '/_app/asset-library'
      path: '/asset-library'
      fullPath: '/asset-library'
      preLoaderRoute: typeof AppAssetLibraryRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/logs/': {
      id: '/_app/logs/'
      path: '/'
      fullPath: '/logs/'
      preLoaderRoute: typeof AppLogsIndexRouteImport
      parentRoute: typeof AppLogsRouteRoute
    }
    '/_app/library/': {
      id: '/_app/library/'
      path: '/'
      fullPath: '/library/'
      preLoaderRoute: typeof AppLibraryIndexRouteImport
      parentRoute: typeof AppLibraryRouteRoute
    }
    '/_app/lens/': {
      id: '/_app/lens/'
      path: '/'
      fullPath: '/lens/'
      preLoaderRoute: typeof AppLensIndexRouteImport
      parentRoute: typeof AppLensRouteRoute
    }
    '/_app/control-room/': {
      id: '/_app/control-room/'
      path: '/'
      fullPath: '/control-room/'
      preLoaderRoute: typeof AppControlRoomIndexRouteImport
      parentRoute: typeof AppControlRoomRouteRoute
    }
    '/_app/asset-library/': {
      id: '/_app/asset-library/'
      path: '/'
      fullPath: '/asset-library/'
      preLoaderRoute: typeof AppAssetLibraryIndexRouteImport
      parentRoute: typeof AppAssetLibraryRouteRoute
    }
    '/_app/studio/robot-teaching': {
      id: '/_app/studio/robot-teaching'
      path: '/robot-teaching'
      fullPath: '/studio/robot-teaching'
      preLoaderRoute: typeof AppStudioRobotTeachingRouteRouteImport
      parentRoute: typeof AppStudioRouteRoute
    }
    '/_app/studio/$view': {
      id: '/_app/studio/$view'
      path: '/$view'
      fullPath: '/studio/$view'
      preLoaderRoute: typeof AppStudioViewRouteRouteImport
      parentRoute: typeof AppStudioRouteRoute
    }
    '/_app/settings/secrets': {
      id: '/_app/settings/secrets'
      path: '/secrets'
      fullPath: '/settings/secrets'
      preLoaderRoute: typeof AppSettingsSecretsRouteRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/lab': {
      id: '/_app/settings/lab'
      path: '/lab'
      fullPath: '/settings/lab'
      preLoaderRoute: typeof AppSettingsLabRouteRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/compliance': {
      id: '/_app/settings/compliance'
      path: '/compliance'
      fullPath: '/settings/compliance'
      preLoaderRoute: typeof AppSettingsComplianceRouteRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/audit-exports': {
      id: '/_app/settings/audit-exports'
      path: '/audit-exports'
      fullPath: '/settings/audit-exports'
      preLoaderRoute: typeof AppSettingsAuditExportsRouteRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/_userManagement': {
      id: '/_app/settings/_userManagement'
      path: ''
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsUserManagementRouteRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/logs/user': {
      id: '/_app/logs/user'
      path: '/user'
      fullPath: '/logs/user'
      preLoaderRoute: typeof AppLogsUserRouteRouteImport
      parentRoute: typeof AppLogsRouteRoute
    }
    '/_app/logs/execution': {
      id: '/_app/logs/execution'
      path: '/execution'
      fullPath: '/logs/execution'
      preLoaderRoute: typeof AppLogsExecutionRouteRouteImport
      parentRoute: typeof AppLogsRouteRoute
    }
    '/_app/library/workflows': {
      id: '/_app/library/workflows'
      path: '/workflows'
      fullPath: '/library/workflows'
      preLoaderRoute: typeof AppLibraryWorkflowsRouteRouteImport
      parentRoute: typeof AppLibraryRouteRoute
    }
    '/_app/library/processes': {
      id: '/_app/library/processes'
      path: '/processes'
      fullPath: '/library/processes'
      preLoaderRoute: typeof AppLibraryProcessesRouteRouteImport
      parentRoute: typeof AppLibraryRouteRoute
    }
    '/_app/control-room/workflow': {
      id: '/_app/control-room/workflow'
      path: '/workflow'
      fullPath: '/control-room/workflow'
      preLoaderRoute: typeof AppControlRoomWorkflowRouteRouteImport
      parentRoute: typeof AppControlRoomRouteRoute
    }
    '/_app/control-room/process': {
      id: '/_app/control-room/process'
      path: '/process'
      fullPath: '/control-room/process'
      preLoaderRoute: typeof AppControlRoomProcessRouteRouteImport
      parentRoute: typeof AppControlRoomRouteRoute
    }
    '/_app/library/workflows/': {
      id: '/_app/library/workflows/'
      path: '/'
      fullPath: '/library/workflows/'
      preLoaderRoute: typeof AppLibraryWorkflowsIndexRouteImport
      parentRoute: typeof AppLibraryWorkflowsRouteRoute
    }
    '/_app/library/processes/': {
      id: '/_app/library/processes/'
      path: '/'
      fullPath: '/library/processes/'
      preLoaderRoute: typeof AppLibraryProcessesIndexRouteImport
      parentRoute: typeof AppLibraryProcessesRouteRoute
    }
    '/_app/lens/$analysisId/': {
      id: '/_app/lens/$analysisId/'
      path: '/$analysisId'
      fullPath: '/lens/$analysisId'
      preLoaderRoute: typeof AppLensAnalysisIdIndexRouteImport
      parentRoute: typeof AppLensRouteRoute
    }
    '/_app/asset-library/$packageId/': {
      id: '/_app/asset-library/$packageId/'
      path: '/$packageId'
      fullPath: '/asset-library/$packageId'
      preLoaderRoute: typeof AppAssetLibraryPackageIdIndexRouteImport
      parentRoute: typeof AppAssetLibraryRouteRoute
    }
    '/_app/notebook/session/$sessionId': {
      id: '/_app/notebook/session/$sessionId'
      path: '/notebook/session/$sessionId'
      fullPath: '/notebook/session/$sessionId'
      preLoaderRoute: typeof AppNotebookSessionSessionIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/settings/_userManagement/users': {
      id: '/_app/settings/_userManagement/users'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AppSettingsUserManagementUsersRouteRouteImport
      parentRoute: typeof AppSettingsUserManagementRouteRoute
    }
    '/_app/settings/_userManagement/roles': {
      id: '/_app/settings/_userManagement/roles'
      path: '/roles'
      fullPath: '/settings/roles'
      preLoaderRoute: typeof AppSettingsUserManagementRolesRouteRouteImport
      parentRoute: typeof AppSettingsUserManagementRouteRoute
    }
    '/_app/library/workflows/$workflowId': {
      id: '/_app/library/workflows/$workflowId'
      path: '/$workflowId'
      fullPath: '/library/workflows/$workflowId'
      preLoaderRoute: typeof AppLibraryWorkflowsWorkflowIdRouteRouteImport
      parentRoute: typeof AppLibraryWorkflowsRouteRoute
    }
    '/_app/library/workflows/$workcellId': {
      id: '/_app/library/workflows/$workcellId'
      path: '/$workcellId'
      fullPath: '/library/workflows/$workcellId'
      preLoaderRoute: typeof AppLibraryWorkflowsWorkcellIdRouteRouteImport
      parentRoute: typeof AppLibraryWorkflowsRouteRoute
    }
    '/_app/library/processes/$processId': {
      id: '/_app/library/processes/$processId'
      path: '/$processId'
      fullPath: '/library/processes/$processId'
      preLoaderRoute: typeof AppLibraryProcessesProcessIdRouteRouteImport
      parentRoute: typeof AppLibraryProcessesRouteRoute
    }
    '/_app/control-room/workflow/$stepId': {
      id: '/_app/control-room/workflow/$stepId'
      path: '/$stepId'
      fullPath: '/control-room/workflow/$stepId'
      preLoaderRoute: typeof AppControlRoomWorkflowStepIdRouteRouteImport
      parentRoute: typeof AppControlRoomWorkflowRouteRoute
    }
    '/_app/control-room/process/$processId': {
      id: '/_app/control-room/process/$processId'
      path: '/$processId'
      fullPath: '/control-room/process/$processId'
      preLoaderRoute: typeof AppControlRoomProcessProcessIdRouteRouteImport
      parentRoute: typeof AppControlRoomProcessRouteRoute
    }
    '/_app/library/workflows/$workflowId/': {
      id: '/_app/library/workflows/$workflowId/'
      path: '/'
      fullPath: '/library/workflows/$workflowId/'
      preLoaderRoute: typeof AppLibraryWorkflowsWorkflowIdIndexRouteImport
      parentRoute: typeof AppLibraryWorkflowsWorkflowIdRouteRoute
    }
    '/_app/library/processes/$processId/': {
      id: '/_app/library/processes/$processId/'
      path: '/'
      fullPath: '/library/processes/$processId/'
      preLoaderRoute: typeof AppLibraryProcessesProcessIdIndexRouteImport
      parentRoute: typeof AppLibraryProcessesProcessIdRouteRoute
    }
    '/_app/control-room/workflow/parallel/': {
      id: '/_app/control-room/workflow/parallel/'
      path: '/parallel'
      fullPath: '/control-room/workflow/parallel'
      preLoaderRoute: typeof AppControlRoomWorkflowParallelIndexRouteImport
      parentRoute: typeof AppControlRoomWorkflowRouteRoute
    }
    '/_app/control-room/workflow/$stepId/': {
      id: '/_app/control-room/workflow/$stepId/'
      path: '/'
      fullPath: '/control-room/workflow/$stepId/'
      preLoaderRoute: typeof AppControlRoomWorkflowStepIdIndexRouteImport
      parentRoute: typeof AppControlRoomWorkflowStepIdRouteRoute
    }
    '/_app/control-room/process/$processId/': {
      id: '/_app/control-room/process/$processId/'
      path: '/'
      fullPath: '/control-room/process/$processId/'
      preLoaderRoute: typeof AppControlRoomProcessProcessIdIndexRouteImport
      parentRoute: typeof AppControlRoomProcessProcessIdRouteRoute
    }
    '/_app/asset-library/$packageId/$assetId/': {
      id: '/_app/asset-library/$packageId/$assetId/'
      path: '/$packageId/$assetId'
      fullPath: '/asset-library/$packageId/$assetId'
      preLoaderRoute: typeof AppAssetLibraryPackageIdAssetIdIndexRouteImport
      parentRoute: typeof AppAssetLibraryRouteRoute
    }
    '/_app/library/workflows/$workflowId/canvas': {
      id: '/_app/library/workflows/$workflowId/canvas'
      path: '/canvas'
      fullPath: '/library/workflows/$workflowId/canvas'
      preLoaderRoute: typeof AppLibraryWorkflowsWorkflowIdCanvasRouteRouteImport
      parentRoute: typeof AppLibraryWorkflowsWorkflowIdRouteRoute
    }
    '/_app/library/workflows/$workcellId/$workflowId': {
      id: '/_app/library/workflows/$workcellId/$workflowId'
      path: '/$workflowId'
      fullPath: '/library/workflows/$workcellId/$workflowId'
      preLoaderRoute: typeof AppLibraryWorkflowsWorkcellIdWorkflowIdRouteRouteImport
      parentRoute: typeof AppLibraryWorkflowsWorkcellIdRouteRoute
    }
    '/_app/library/processes/$processId/canvas': {
      id: '/_app/library/processes/$processId/canvas'
      path: '/canvas'
      fullPath: '/library/processes/$processId/canvas'
      preLoaderRoute: typeof AppLibraryProcessesProcessIdCanvasRouteRouteImport
      parentRoute: typeof AppLibraryProcessesProcessIdRouteRoute
    }
    '/_app/control-room/process/$processId/labware/$labwareId': {
      id: '/_app/control-room/process/$processId/labware/$labwareId'
      path: '/labware/$labwareId'
      fullPath: '/control-room/process/$processId/labware/$labwareId'
      preLoaderRoute: typeof AppControlRoomProcessProcessIdLabwareLabwareIdRouteImport
      parentRoute: typeof AppControlRoomProcessProcessIdRouteRoute
    }
  }
}

interface AppAssetLibraryRouteRouteChildren {
  AppAssetLibraryIndexRoute: typeof AppAssetLibraryIndexRoute
  AppAssetLibraryPackageIdIndexRoute: typeof AppAssetLibraryPackageIdIndexRoute
  AppAssetLibraryPackageIdAssetIdIndexRoute: typeof AppAssetLibraryPackageIdAssetIdIndexRoute
}

const AppAssetLibraryRouteRouteChildren: AppAssetLibraryRouteRouteChildren = {
  AppAssetLibraryIndexRoute: AppAssetLibraryIndexRoute,
  AppAssetLibraryPackageIdIndexRoute: AppAssetLibraryPackageIdIndexRoute,
  AppAssetLibraryPackageIdAssetIdIndexRoute:
    AppAssetLibraryPackageIdAssetIdIndexRoute,
}

const AppAssetLibraryRouteRouteWithChildren =
  AppAssetLibraryRouteRoute._addFileChildren(AppAssetLibraryRouteRouteChildren)

interface AppControlRoomProcessProcessIdRouteRouteChildren {
  AppControlRoomProcessProcessIdIndexRoute: typeof AppControlRoomProcessProcessIdIndexRoute
  AppControlRoomProcessProcessIdLabwareLabwareIdRoute: typeof AppControlRoomProcessProcessIdLabwareLabwareIdRoute
}

const AppControlRoomProcessProcessIdRouteRouteChildren: AppControlRoomProcessProcessIdRouteRouteChildren =
  {
    AppControlRoomProcessProcessIdIndexRoute:
      AppControlRoomProcessProcessIdIndexRoute,
    AppControlRoomProcessProcessIdLabwareLabwareIdRoute:
      AppControlRoomProcessProcessIdLabwareLabwareIdRoute,
  }

const AppControlRoomProcessProcessIdRouteRouteWithChildren =
  AppControlRoomProcessProcessIdRouteRoute._addFileChildren(
    AppControlRoomProcessProcessIdRouteRouteChildren,
  )

interface AppControlRoomProcessRouteRouteChildren {
  AppControlRoomProcessProcessIdRouteRoute: typeof AppControlRoomProcessProcessIdRouteRouteWithChildren
}

const AppControlRoomProcessRouteRouteChildren: AppControlRoomProcessRouteRouteChildren =
  {
    AppControlRoomProcessProcessIdRouteRoute:
      AppControlRoomProcessProcessIdRouteRouteWithChildren,
  }

const AppControlRoomProcessRouteRouteWithChildren =
  AppControlRoomProcessRouteRoute._addFileChildren(
    AppControlRoomProcessRouteRouteChildren,
  )

interface AppControlRoomWorkflowStepIdRouteRouteChildren {
  AppControlRoomWorkflowStepIdIndexRoute: typeof AppControlRoomWorkflowStepIdIndexRoute
}

const AppControlRoomWorkflowStepIdRouteRouteChildren: AppControlRoomWorkflowStepIdRouteRouteChildren =
  {
    AppControlRoomWorkflowStepIdIndexRoute:
      AppControlRoomWorkflowStepIdIndexRoute,
  }

const AppControlRoomWorkflowStepIdRouteRouteWithChildren =
  AppControlRoomWorkflowStepIdRouteRoute._addFileChildren(
    AppControlRoomWorkflowStepIdRouteRouteChildren,
  )

interface AppControlRoomWorkflowRouteRouteChildren {
  AppControlRoomWorkflowStepIdRouteRoute: typeof AppControlRoomWorkflowStepIdRouteRouteWithChildren
  AppControlRoomWorkflowParallelIndexRoute: typeof AppControlRoomWorkflowParallelIndexRoute
}

const AppControlRoomWorkflowRouteRouteChildren: AppControlRoomWorkflowRouteRouteChildren =
  {
    AppControlRoomWorkflowStepIdRouteRoute:
      AppControlRoomWorkflowStepIdRouteRouteWithChildren,
    AppControlRoomWorkflowParallelIndexRoute:
      AppControlRoomWorkflowParallelIndexRoute,
  }

const AppControlRoomWorkflowRouteRouteWithChildren =
  AppControlRoomWorkflowRouteRoute._addFileChildren(
    AppControlRoomWorkflowRouteRouteChildren,
  )

interface AppControlRoomRouteRouteChildren {
  AppControlRoomProcessRouteRoute: typeof AppControlRoomProcessRouteRouteWithChildren
  AppControlRoomWorkflowRouteRoute: typeof AppControlRoomWorkflowRouteRouteWithChildren
  AppControlRoomIndexRoute: typeof AppControlRoomIndexRoute
}

const AppControlRoomRouteRouteChildren: AppControlRoomRouteRouteChildren = {
  AppControlRoomProcessRouteRoute: AppControlRoomProcessRouteRouteWithChildren,
  AppControlRoomWorkflowRouteRoute:
    AppControlRoomWorkflowRouteRouteWithChildren,
  AppControlRoomIndexRoute: AppControlRoomIndexRoute,
}

const AppControlRoomRouteRouteWithChildren =
  AppControlRoomRouteRoute._addFileChildren(AppControlRoomRouteRouteChildren)

interface AppLensRouteRouteChildren {
  AppLensIndexRoute: typeof AppLensIndexRoute
  AppLensAnalysisIdIndexRoute: typeof AppLensAnalysisIdIndexRoute
}

const AppLensRouteRouteChildren: AppLensRouteRouteChildren = {
  AppLensIndexRoute: AppLensIndexRoute,
  AppLensAnalysisIdIndexRoute: AppLensAnalysisIdIndexRoute,
}

const AppLensRouteRouteWithChildren = AppLensRouteRoute._addFileChildren(
  AppLensRouteRouteChildren,
)

interface AppLibraryProcessesProcessIdRouteRouteChildren {
  AppLibraryProcessesProcessIdCanvasRouteRoute: typeof AppLibraryProcessesProcessIdCanvasRouteRoute
  AppLibraryProcessesProcessIdIndexRoute: typeof AppLibraryProcessesProcessIdIndexRoute
}

const AppLibraryProcessesProcessIdRouteRouteChildren: AppLibraryProcessesProcessIdRouteRouteChildren =
  {
    AppLibraryProcessesProcessIdCanvasRouteRoute:
      AppLibraryProcessesProcessIdCanvasRouteRoute,
    AppLibraryProcessesProcessIdIndexRoute:
      AppLibraryProcessesProcessIdIndexRoute,
  }

const AppLibraryProcessesProcessIdRouteRouteWithChildren =
  AppLibraryProcessesProcessIdRouteRoute._addFileChildren(
    AppLibraryProcessesProcessIdRouteRouteChildren,
  )

interface AppLibraryProcessesRouteRouteChildren {
  AppLibraryProcessesProcessIdRouteRoute: typeof AppLibraryProcessesProcessIdRouteRouteWithChildren
  AppLibraryProcessesIndexRoute: typeof AppLibraryProcessesIndexRoute
}

const AppLibraryProcessesRouteRouteChildren: AppLibraryProcessesRouteRouteChildren =
  {
    AppLibraryProcessesProcessIdRouteRoute:
      AppLibraryProcessesProcessIdRouteRouteWithChildren,
    AppLibraryProcessesIndexRoute: AppLibraryProcessesIndexRoute,
  }

const AppLibraryProcessesRouteRouteWithChildren =
  AppLibraryProcessesRouteRoute._addFileChildren(
    AppLibraryProcessesRouteRouteChildren,
  )

interface AppLibraryWorkflowsWorkcellIdRouteRouteChildren {
  AppLibraryWorkflowsWorkcellIdWorkflowIdRouteRoute: typeof AppLibraryWorkflowsWorkcellIdWorkflowIdRouteRoute
}

const AppLibraryWorkflowsWorkcellIdRouteRouteChildren: AppLibraryWorkflowsWorkcellIdRouteRouteChildren =
  {
    AppLibraryWorkflowsWorkcellIdWorkflowIdRouteRoute:
      AppLibraryWorkflowsWorkcellIdWorkflowIdRouteRoute,
  }

const AppLibraryWorkflowsWorkcellIdRouteRouteWithChildren =
  AppLibraryWorkflowsWorkcellIdRouteRoute._addFileChildren(
    AppLibraryWorkflowsWorkcellIdRouteRouteChildren,
  )

interface AppLibraryWorkflowsWorkflowIdRouteRouteChildren {
  AppLibraryWorkflowsWorkflowIdCanvasRouteRoute: typeof AppLibraryWorkflowsWorkflowIdCanvasRouteRoute
  AppLibraryWorkflowsWorkflowIdIndexRoute: typeof AppLibraryWorkflowsWorkflowIdIndexRoute
}

const AppLibraryWorkflowsWorkflowIdRouteRouteChildren: AppLibraryWorkflowsWorkflowIdRouteRouteChildren =
  {
    AppLibraryWorkflowsWorkflowIdCanvasRouteRoute:
      AppLibraryWorkflowsWorkflowIdCanvasRouteRoute,
    AppLibraryWorkflowsWorkflowIdIndexRoute:
      AppLibraryWorkflowsWorkflowIdIndexRoute,
  }

const AppLibraryWorkflowsWorkflowIdRouteRouteWithChildren =
  AppLibraryWorkflowsWorkflowIdRouteRoute._addFileChildren(
    AppLibraryWorkflowsWorkflowIdRouteRouteChildren,
  )

interface AppLibraryWorkflowsRouteRouteChildren {
  AppLibraryWorkflowsWorkcellIdRouteRoute: typeof AppLibraryWorkflowsWorkcellIdRouteRouteWithChildren
  AppLibraryWorkflowsWorkflowIdRouteRoute: typeof AppLibraryWorkflowsWorkflowIdRouteRouteWithChildren
  AppLibraryWorkflowsIndexRoute: typeof AppLibraryWorkflowsIndexRoute
}

const AppLibraryWorkflowsRouteRouteChildren: AppLibraryWorkflowsRouteRouteChildren =
  {
    AppLibraryWorkflowsWorkcellIdRouteRoute:
      AppLibraryWorkflowsWorkcellIdRouteRouteWithChildren,
    AppLibraryWorkflowsWorkflowIdRouteRoute:
      AppLibraryWorkflowsWorkflowIdRouteRouteWithChildren,
    AppLibraryWorkflowsIndexRoute: AppLibraryWorkflowsIndexRoute,
  }

const AppLibraryWorkflowsRouteRouteWithChildren =
  AppLibraryWorkflowsRouteRoute._addFileChildren(
    AppLibraryWorkflowsRouteRouteChildren,
  )

interface AppLibraryRouteRouteChildren {
  AppLibraryProcessesRouteRoute: typeof AppLibraryProcessesRouteRouteWithChildren
  AppLibraryWorkflowsRouteRoute: typeof AppLibraryWorkflowsRouteRouteWithChildren
  AppLibraryIndexRoute: typeof AppLibraryIndexRoute
}

const AppLibraryRouteRouteChildren: AppLibraryRouteRouteChildren = {
  AppLibraryProcessesRouteRoute: AppLibraryProcessesRouteRouteWithChildren,
  AppLibraryWorkflowsRouteRoute: AppLibraryWorkflowsRouteRouteWithChildren,
  AppLibraryIndexRoute: AppLibraryIndexRoute,
}

const AppLibraryRouteRouteWithChildren = AppLibraryRouteRoute._addFileChildren(
  AppLibraryRouteRouteChildren,
)

interface AppLogsRouteRouteChildren {
  AppLogsExecutionRouteRoute: typeof AppLogsExecutionRouteRoute
  AppLogsUserRouteRoute: typeof AppLogsUserRouteRoute
  AppLogsIndexRoute: typeof AppLogsIndexRoute
}

const AppLogsRouteRouteChildren: AppLogsRouteRouteChildren = {
  AppLogsExecutionRouteRoute: AppLogsExecutionRouteRoute,
  AppLogsUserRouteRoute: AppLogsUserRouteRoute,
  AppLogsIndexRoute: AppLogsIndexRoute,
}

const AppLogsRouteRouteWithChildren = AppLogsRouteRoute._addFileChildren(
  AppLogsRouteRouteChildren,
)

interface AppSettingsUserManagementRouteRouteChildren {
  AppSettingsUserManagementRolesRouteRoute: typeof AppSettingsUserManagementRolesRouteRoute
  AppSettingsUserManagementUsersRouteRoute: typeof AppSettingsUserManagementUsersRouteRoute
}

const AppSettingsUserManagementRouteRouteChildren: AppSettingsUserManagementRouteRouteChildren =
  {
    AppSettingsUserManagementRolesRouteRoute:
      AppSettingsUserManagementRolesRouteRoute,
    AppSettingsUserManagementUsersRouteRoute:
      AppSettingsUserManagementUsersRouteRoute,
  }

const AppSettingsUserManagementRouteRouteWithChildren =
  AppSettingsUserManagementRouteRoute._addFileChildren(
    AppSettingsUserManagementRouteRouteChildren,
  )

interface AppSettingsRouteRouteChildren {
  AppSettingsUserManagementRouteRoute: typeof AppSettingsUserManagementRouteRouteWithChildren
  AppSettingsAuditExportsRouteRoute: typeof AppSettingsAuditExportsRouteRoute
  AppSettingsComplianceRouteRoute: typeof AppSettingsComplianceRouteRoute
  AppSettingsLabRouteRoute: typeof AppSettingsLabRouteRoute
  AppSettingsSecretsRouteRoute: typeof AppSettingsSecretsRouteRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteRouteChildren: AppSettingsRouteRouteChildren = {
  AppSettingsUserManagementRouteRoute:
    AppSettingsUserManagementRouteRouteWithChildren,
  AppSettingsAuditExportsRouteRoute: AppSettingsAuditExportsRouteRoute,
  AppSettingsComplianceRouteRoute: AppSettingsComplianceRouteRoute,
  AppSettingsLabRouteRoute: AppSettingsLabRouteRoute,
  AppSettingsSecretsRouteRoute: AppSettingsSecretsRouteRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteRouteWithChildren =
  AppSettingsRouteRoute._addFileChildren(AppSettingsRouteRouteChildren)

interface AppStudioRouteRouteChildren {
  AppStudioViewRouteRoute: typeof AppStudioViewRouteRoute
  AppStudioRobotTeachingRouteRoute: typeof AppStudioRobotTeachingRouteRoute
}

const AppStudioRouteRouteChildren: AppStudioRouteRouteChildren = {
  AppStudioViewRouteRoute: AppStudioViewRouteRoute,
  AppStudioRobotTeachingRouteRoute: AppStudioRobotTeachingRouteRoute,
}

const AppStudioRouteRouteWithChildren = AppStudioRouteRoute._addFileChildren(
  AppStudioRouteRouteChildren,
)

interface AppRouteRouteChildren {
  AppAssetLibraryRouteRoute: typeof AppAssetLibraryRouteRouteWithChildren
  AppControlRoomRouteRoute: typeof AppControlRoomRouteRouteWithChildren
  AppLensRouteRoute: typeof AppLensRouteRouteWithChildren
  AppLibraryRouteRoute: typeof AppLibraryRouteRouteWithChildren
  AppLogsRouteRoute: typeof AppLogsRouteRouteWithChildren
  AppSettingsRouteRoute: typeof AppSettingsRouteRouteWithChildren
  AppStudioRouteRoute: typeof AppStudioRouteRouteWithChildren
  AppCallbackRoute: typeof AppCallbackRoute
  AppNotebookSessionSessionIdRoute: typeof AppNotebookSessionSessionIdRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppAssetLibraryRouteRoute: AppAssetLibraryRouteRouteWithChildren,
  AppControlRoomRouteRoute: AppControlRoomRouteRouteWithChildren,
  AppLensRouteRoute: AppLensRouteRouteWithChildren,
  AppLibraryRouteRoute: AppLibraryRouteRouteWithChildren,
  AppLogsRouteRoute: AppLogsRouteRouteWithChildren,
  AppSettingsRouteRoute: AppSettingsRouteRouteWithChildren,
  AppStudioRouteRoute: AppStudioRouteRouteWithChildren,
  AppCallbackRoute: AppCallbackRoute,
  AppNotebookSessionSessionIdRoute: AppNotebookSessionSessionIdRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
